import React from 'react'
import { useNavigate, useLocation, useParams, useSearchParams } from 'react-router'

const withRouter = (Component) => {
  return (props) => {
    const history = useNavigate()
    const location = useLocation()
    const params = useParams()
    const searchParams = useSearchParams()

    return (
      <Component
        history={history}
        location={location}
        params={params}
        searchParams={searchParams}
        {...props}
      />
    )
  }
}

export default withRouter
